import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/functions';
import 'firebase/compat/storage';

firebase.initializeApp({
  apiKey: "AIzaSyD9tHy9nYf29ezvNwtU0lgLs3dxl8rfGuk",
  authDomain: "matmissionen-bb65b.firebaseapp.com",
  projectId: "matmissionen-bb65b",
  storageBucket: "matmissionen-bb65b.appspot.com",
  messagingSenderId: "476299882535",
  appId: "1:476299882535:web:43ebf960bf2dccc7d19e02",
  measurementId: "G-LLZDJHH5Z4"
});

export const functions = firebase.app().functions('europe-west3');
export const firestore = firebase.firestore();
export const auth = firebase.auth();
export const storage = firebase.storage();

// Local emulator?
if (process.env.REACT_APP_EMULATOR === 'true') {
  const HOST = "localhost";
  // const HOST = "192.168.43.178";
  functions.useEmulator(HOST, 5001);
  firestore.useEmulator(HOST, 8080);
  auth.useEmulator(`http://${HOST}:9099`);
  storage.useEmulator(HOST, 9199);
}

export default firebase;